import React from "react";

import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";
import { FcGoogle } from "@react-icons/all-files/fc/FcGoogle";
import { MdVoicemail } from "@react-icons/all-files/md/MdVoicemail";

import Eye from "../Eye";

import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { createXfindGoogleAuth } from "../../../3- actions/users";

function MainInterface({ setPopUp, popup, setInterfaces }) {
  const dispatch = useDispatch();
  const userId = JSON.parse(localStorage.getItem("profile"))?.result?._id;

  const url = "https://eyenovel-backend.vercel.app/users/auth/google";
  const googleLogin = () => window.open(url, "_self");
  useEffect(() => {
    if (!userId) {
      dispatch(createXfindGoogleAuth());
    }
  }, [dispatch, userId]);

  return (
    <div>
      <div
        className={
          popup
            ? "fixed overflow-y-scroll sm:overflow-visible inset-x-0 inset-y-0 z-[1000] w-full md:w-full lg:w-[75%] xl:w-[60%] 2xl:w-[40%] h-full md:h-fit m-auto bg-tertiary   -translate-y-[0%] opacity-100 duration-500 ease-in-out"
            : "fixed overflow-y-scroll sm:overflow-visible inset-x-0 inset-y-0 z-[1000] w-full md:w-full lg:w-[75%] xl:w-[60%] 2xl:w-[40%] h-full md:h-fit m-auto bg-tertiary   -translate-y-[-200%] opacity-0 duration-500 ease-in-out"
        }
      >
        {/* cancel button */}
        <div
          onClick={() => setPopUp(false)}
          className=" cursor-pointer absolute bg-error/0 md:bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
        >
          <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
        </div>
        <div>
          <div className="px-[15px] md:px-0 w-full h-auto bg-primary gap-y-4 py-24 md:py-14 flex justify-center items-center flex-col text-center ">
            <div className="zoom">
              <Eye />
            </div>
            <div className="gap-y-1 flex flex-col">
              <h2 className="text-tertiary font-size">Welcome to EyeNovel</h2>
              <p className="text-tertiary text-[14px] md:text-[16px]  capitalize">
                Access tons of novels and comics by a single tap
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-y-12 my-20">
            {/* login ways */}
            <div className="px-[15px] md:px-20">
              <div className="flex flex-col gap-y-4">
                <div onClick={googleLogin}>
                  <button
                    className="cursor-pointer hover:bg-secondary hover:text-tertiary duration-500 ease-in-out relative flex flex-row-reverse h-[52px] justify-start text-center px-8 sm:justify-center items-center w-full border-[1px] border-secondary"
                    type="submit"
                  >
                    <h2 className=" font-SoraR text-[14px] sm:text-[16px]">
                      Login With Google
                    </h2>
                    <div className="absolute top-1/2 -translate-y-1/2 left-5 md:left-10 scale-[1.5]">
                      <FcGoogle />
                    </div>
                  </button>
                </div>

                <div
                  onClick={() => setInterfaces(2)}
                  className="cursor-pointer hover:bg-primary/90 duration-500 ease-in-out relative flex flex-row-reverse h-[52px] justify-start text-center px-8 sm:justify-center items-center w-full  bg-primary "
                >
                  <h2 className="text-[14px] sm:text-[16px] font-SoraR text-tertiary">
                    Login With Email
                  </h2>
                  <div className="absolute text-tertiary top-1/2 -translate-y-1/2 left-5 md:left-10 scale-[1.5]">
                    <MdVoicemail />
                  </div>
                </div>
              </div>
            </div>
            {/* line */}
            <div className="w-1/3 m-auto h-[1px] bg-secondary/20"></div>
            {/* Don't Have An Account? */}
            <div className=" px-[15px] md:px-0 flex flex-wrap text-center gap-y-2 md:gap-y-0 gap-x-4 justify-center items-center ">
              <h2 className=" font-SoraR text-[14px] sm:text-[16px] capitalize">
                Don't have an account?
              </h2>
              <span
                onClick={() => setInterfaces(1)}
                className="text-[14px] sm:text-[16px] cursor-pointer font-SoraS text-primary linebutton relative duration-500 ease-in-out"
              >
                REGISTER
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainInterface;
